import { Typography } from '../../components/Typography/Typography';

interface PodcastMetaProps {
  title: string;
  description: string;
  seriesTitle: string;
  publishedDate: string;
}

export const PodcastMeta = ({
  title,
  description,
  seriesTitle,
  publishedDate,
}: PodcastMetaProps) => {
  const formattedTitle = title.replace(
    /([A-Za-zÀ-ÖØ-öø-ÿ])-([A-Za-zÀ-ÖØ-öø-ÿ])/g,
    '$1\u2011$2'
  );

  return (
    <div className="vgp-podcast-layout-meta">
      <div className="vgp-podcast-layout-meta-header">
        {seriesTitle && (
          <Typography variant="label" size="small" color="secondary">
            {seriesTitle}
          </Typography>
        )}
        {seriesTitle && publishedDate && (
          <Typography variant="label" size="small" color="secondary">
            •
          </Typography>
        )}
        {publishedDate && (
          <Typography variant="label" size="small" color="secondary">
            {publishedDate}
          </Typography>
        )}
      </div>
      <Typography variant="title" size="small" bold color="primary">
        {formattedTitle}
      </Typography>
      {description && (
        <Typography
          variant="label"
          size="medium"
          color="secondary"
          className="vgp-podcast-layout-description"
        >
          {description}
        </Typography>
      )}
    </div>
  );
};
